module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-2-10"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 10")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("When I closed, my sales for the day were pathetic. I’d sold an old spittoon to a young man, two little doilies to a young girl, and a simple candlestick to her girlfriend. I knew my heat cost for the day would be more than what I’d earned. I was learning that cold drafts were abundant in this older house. I had to be more creative in my advertising, like perhaps participating in local events to attract more customers. I knew little about selling online, but if anyone would know, it would be Alex.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I dressed in casual black for my date with Marc and put on winter boots for the first time this season. I knew Marc would be in a suit, so I didn’t want to go too casual. I got a text close to five o’clock telling me that Marc was running late. Since I was ready to go, I helped myself to a glass of wine. I went out on the upper porch to try out my new cushions. It was chilly out there, but as I stared into the darkness, I felt I was somewhere else, and all was well.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Still lurking in the back of my mind were my finances. With winter ahead, I wondered what else I could do to improve my income. I had to make payments to Carrie Mae, and taxes would be coming due at the end of the year. It seemed that other shops were busier, which made me begin to realize that my location put me at a disadvantage. I’m sure there were those who would tell me, “I told you so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Marc finally arrived at a quarter to six, and I rushed downstairs to answer the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Sorry, Lily,” he said apologetically. “Everything was running behind today.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I smiled as I gave him a slight hug and a quick kiss on his cold cheek. His look of surprise was priceless.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Well, absence must make the heart grow fonder,” he teased.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m just happy to see you. I guess we’d better go. The restaurant is holding our reservation, but can you take a quick peek at my porches? They are complete and I’m so excited.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("First, he looked at the porch downstairs and confirmed that my using it for garden merchandise was a clever idea. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m putting in some outdoor lighting around the house, so I can see what’s going on out there in the dark. My security guy said he could easily do that for me. When we have snow, the view out here will be awesome.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“It may be here sooner than you think, because there’s snow in tonight’s forecast.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I hadn’t heard that. Let me show you the second-story porch. It will just take a minute.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Marc followed me upstairs, where he exclaimed, “Now you’re talking! This is awesome, Lily. You have great taste, and I can’t believe the transition from what it was like before.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Thanks. I decided there may be times when I could sleep out here as well. Well, okay, we’d better go!” As we began to go down the stairs, I noticed Marc looking toward my bedroom. Before I moved in, Marc had briefly seen the upstairs.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("The Silly Goose restaurant was crowded, as always. I saw a few familiar faces, and one of them was Lisa, who was a great customer of Carrie Mae’s. She had also bought a quilt from me. I nodded and smiled at her. Marc was impressed with the atmosphere. We made small talk after the waitress described their specials, and I answered a couple of questions from Marc.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“So, you were pleased with the outcome of your meeting?” I asked, wanting to hear about his day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m not sure. Time will tell. Sometimes things take such a long time with some of these transactions. It’s hard, but that’s what the courts are for.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "bodytext6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a222e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Lily_Girl_split13.vue
// module id = 99
// module chunks = 0